import styled from "styled-components";
import { BodySmall, HeadLine1 } from "../../../components/typography/styled";
import { Link as RouterLink } from "react-router-dom";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 10px 20px;
`;

export const HeadWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

export const Title = styled(HeadLine1)`
  color: ${({ theme }) => theme.palette[800]};
  margin: 10px 0;
`;

export const TabsRow = styled.div`
  border-bottom: ${({ theme }) => `1px solid ${theme.grey[350]}`};
  position: relative;
  padding-bottom: 2px;
  & > div {
    position: absolute;
    bottom: -1px;
    left: 0;
  }
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: ${({ theme }) => theme.base.white};
  border: 1px solid ${({ theme }) => theme.grey[350]};
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
`;

export const SectionTitle = styled(BodySmall)`
  color: ${({ theme }) => theme.palette[700]};
  text-transform: uppercase;
  letter-spacing: 0.04em;
`;

export const SelectionRow = styled.div`
  display: flex;
  gap: 16px;
  align-items: flex-start;
  flex-wrap: wrap;
`;

export const InfoBox = styled.div`
  border: 1px solid ${({ theme }) => theme.grey[350]};
  border-radius: 10px;
  padding: 14px 16px;
  background: ${({ theme }) => theme.palette[25] || theme.base.white};
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const InfoTitle = styled.div`
  font-weight: 700;
  color: ${({ theme }) => theme.grey[900]};
`;

export const InfoText = styled.div`
  color: ${({ theme }) => theme.grey[700]};
  line-height: 20px;
  font-size: 14px;
`;

export const List = styled.ul`
  padding-left: 18px;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const InlineLink = styled(RouterLink)`
  color: ${({ theme }) => theme.primary[600]};
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

export const PermissionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const TabsWrapper = styled.div`
  max-width: 100%;
  overflow-x: auto;
`;

export const ActionsRow = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const EmptyState = styled.div`
  color: ${({ theme }) => theme.grey[700]};
  font-size: 14px;
`;
